import { soadT6Part1DataSchema } from "../../schemas/index.js";
export const soadT6Part1Template = {
    signing: {
        userOrTeamRequirement: {
            accreditation: [],
            teamType: ["soad"],
        },
    },
    formBuilderFields: [
        {
            type: "practitioner",
            field: "practitioner",
            label: "SOAD name and address",
            hideWarningBanners: true,
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "I am a registered medical practitioner appointed for the purposes of Part 4 of the Act (a SOAD), and have consulted",
            ],
        },
        // Consultees
        {
            type: "label",
            showStaticLabel: true,
            label: ["Consultee’s Full Name and Profession"],
        },
        {
            type: "readonly",
            textFn: (_data, context) => {
                const part4 = context.previousPartsFormData.find((s) => s.section === "consulteeDetails")?.data;
                const firstConsulteeName = part4?.firstConsulteeName?.trim();
                const firstConsulteeProfession = part4?.firstConsulteeProfession?.trim();
                const secondConsulteeName = part4?.secondConsulteeName?.trim();
                const secondConsulteeProfession = part4?.secondConsulteeProfession?.trim();
                return firstConsulteeName &&
                    firstConsulteeProfession &&
                    secondConsulteeName &&
                    secondConsulteeProfession
                    ? [
                        `${firstConsulteeName}, ${firstConsulteeProfession}`,
                        `${secondConsulteeName}, ${secondConsulteeProfession}`,
                    ]
                    : ["Please complete the Consultee Details section."];
            },
            afterLabel: "Taken from the ‘Consultee Details’ section which you completed earlier.",
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "who have been professionally concerned with the medical treatment of the patient named above.",
            ],
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "I certify that the patient is not capable of understanding the nature, purpose and likely effects of:",
            ],
        },
        {
            type: "textbox",
            field: "treatment",
            label: "Enter description of treatment or plan of treatment.",
            rows: "5",
            copyFrom: {
                valueFn: (_data, context) => {
                    const part5 = context.previousPartsFormData.find((s) => s.section === "soadAuthorisation")?.data;
                    return [part5?.planAuthorisedEct, part5?.timeLimitCertificateDuration]
                        .filter(Boolean)
                        .join("\n\n");
                },
                label: "Copy from SRF Treatment plan",
            },
            afterLabel: "Include clearly if the certificate is only to apply to any or all of the treatment for a specific period.",
        },
        {
            type: "label",
            showStaticLabel: true,
            label: ["but that it is appropriate for the treatment to be given."],
        },
        {
            type: "textbox",
            field: "reasons",
            label: "My reasons are as below",
            rows: "5",
            copyFrom: {
                valueFn: (_data, context) => {
                    const part2 = context.previousPartsFormData.find((s) => s.section === "diagnosisAndHistory")?.data;
                    const part5 = context.previousPartsFormData.find((s) => s.section === "soadAuthorisation")?.data;
                    return [
                        part2?.diagnosis,
                        part2?.assessment,
                        part5?.timeLimitCertificateReason,
                        part5?.interimS61Reasons,
                    ]
                        .filter(Boolean)
                        .join("\n\n");
                },
                label: "Copy from SRF Reasons",
            },
            afterLabel: "Indicate if, in your opinion, disclosure of the reasons to the patient would be likely to cause serious harm to the physical or mental health of the patient, or to that of any other person.",
        },
        {
            type: "branch",
            field: "disclosureHarmful",
            label: "Would disclosure of these reasons to the patient be likely to cause serious harm to the physical or mental health of the patient, or of any other person?",
            afterLabel: "Recording yes adds a warning for anyone viewing this certificate. It does not appear on the certificate itself or the downloaded PDF.",
            branches: [
                { fieldValue: false, label: "No", fields: [], fieldsOwned: [] },
                { fieldValue: true, label: "Yes", fields: [], fieldsOwned: [] },
            ],
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "I further certify that giving the treatment described above to the patient would not conflict with –",
            ],
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "(i) any decision of an attorney appointed under a Lasting Power of Attorney or deputy (appointed by the Court of Protection) of the patient as provided for by the Mental Capacity Act 2005",
            ],
        },
        {
            type: "label",
            showStaticLabel: true,
            label: ["(ii) any decision of the Court of Protection, or"],
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "(iii) any advance decision to refuse treatment that is valid and applicable under the Mental Capacity Act 2005.",
            ],
        },
    ],
    dataSchema: soadT6Part1DataSchema,
};
export const soadT6V1Base = {
    id: "mha-soad-t6",
    category: "soad",
    version: "1.0",
    status: "active",
    formName: "T6",
    section: "58A(5)",
    parts: [soadT6Part1Template],
    description: "Certificate of second opinion (patients who are not capable of understanding the nature, purpose and likely effects of the treatment)",
    extractGenericData: () => ({}),
};
//# sourceMappingURL=soad-t6.js.map